import React, {useContext} from 'react';

import {Backdrop} from '@mui/material';
import Box from '@mui/material/Box';
import {useTranslation} from 'react-i18next';

import CancellationContext from './CancellationContext';
import CancelFormContent from './CancellationFormContent';
import CancellationResult from './CancellationResult';
import {VIEW_STATE} from './Cancellations';
import {
  CancellationsContainer,
  EventContainer,
  EventStack,
  MainContainer,
  MainContainerContent,
} from './Style';

import PoweredBy from '../PoweredBy';

import ApptCard from 'Components/ApptCard';
import MessageDisplay from 'Components/MessageDisplay';
import ErrorDisplay from 'Components/MessageDisplay/ErrorDisplay';
import PolicyTerms from 'Components/PolicyTerms';
import ZmSpinner from 'Components/ZmSpinner';
import {
  getEventEndTime,
} from 'Utils/apptAvailabilityUtils';


/**
 * Cancellations Page Component for Desktop Devices
 * @param {Object} props
 * @return {ReactElement}
 */
export default function CancellationDesktop(props) {
  // Optionally pass in props from parsing b64
  // const {
  //   appointmentId,
  //   calendarId,
  // } = props;
  const {
    attendeeId,
    cancelResultType,
    currView,
    errorInfo,
    eventInfo,
    isLoaded,
    onCancel,
    onReschedule,
    setCurrView,
    timeZone,
  } = useContext(CancellationContext);
  const {t} = useTranslation();

  const isCciAccount = eventInfo?.isCciEvent;

  const isEventExpired = getEventEndTime(eventInfo) < new Date();

  return (
    <EventContainer>
      {(!isLoaded || errorInfo.isError) ?
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100%',
          }}
        >
          {(errorInfo.isError) ? (
            <ErrorDisplay errorInfo={errorInfo}/>
          ) :
            <ZmSpinner size="80" absolute />
          }
        </Box> :
        (isEventExpired) ?
        <MessageDisplay
          header={t('cancellation.cancelEventExpiredHeader')}
          body={t('cancellation.cancelEventExpiredMsg')}
          isCciAccount={isCciAccount}
          isExpired={true}
        /> :
        <>
          <Backdrop
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 1,
              position: 'absolute',
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
            }}
            open={!isLoaded}
          >
            <ZmSpinner size="80" absolute />
          </Backdrop>

          <EventStack>
            <MainContainer>
              <MainContainerContent>
                {(cancelResultType) ?
                  <CancellationResult
                    eventInfo={eventInfo}
                    cancelResult={cancelResultType}
                  /> :
                  (currView === VIEW_STATE.HOME_VIEW) ?
                  <CancellationsContainer>
                    <ApptCard
                      eventInfo={eventInfo}
                      timeZone={timeZone}
                      displayName={eventInfo?.hostDisplayName}
                      guests={eventInfo?.guests}
                      onCancel={onCancel}
                      onReschedule={onReschedule}
                      showAutoRefundPolicy={true}
                    />
                  </CancellationsContainer> :
                  <CancelFormContent
                    attendeeId={attendeeId}
                    eventInfo={eventInfo}
                    onSuccess={() => setCurrView(VIEW_STATE.CONFIRM_VIEW)}
                    onBackCancel={() => setCurrView(VIEW_STATE.HOME_VIEW)}
                  />
                }
                {!isCciAccount && <PoweredBy />}
                <PolicyTerms />
              </MainContainerContent>
            </MainContainer>
          </EventStack>
        </>
      }
    </EventContainer>
  );
}
